//# sourceMappingURL=ask.mjs.map
/// <reference types="./ask.d.mts" />
import * as $fetch from "../../gleam_fetch/gleam/fetch.mjs";
import * as $form_data from "../../gleam_fetch/gleam/fetch/form_data.mjs";
import * as $http from "../../gleam_http/gleam/http.mjs";
import * as $request from "../../gleam_http/gleam/http/request.mjs";
import * as $response from "../../gleam_http/gleam/http/response.mjs";
import * as $p from "../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $dynamic from "../../gleam_stdlib/gleam/dynamic.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $uri from "../../gleam_stdlib/gleam/uri.mjs";
import * as $assoc from "../../tiamat/gleam/assoc.mjs";
import * as $endpoints from "../altar/endpoints.mjs";
import * as $path from "../altar/path.mjs";
import { Ok, Error, toList, CustomType as $CustomType, makeError } from "../gleam.mjs";
import * as $posthog from "../posthog.mjs";

const FILEPATH = "src/altar/ask.gleam";

export class Loki extends $CustomType {}
export const Service$Loki = () => new Loki();
export const Service$isLoki = (value) => value instanceof Loki;

export class Heimdall extends $CustomType {}
export const Service$Heimdall = () => new Heimdall();
export const Service$isHeimdall = (value) => value instanceof Heimdall;

export class Nabu extends $CustomType {}
export const Service$Nabu = () => new Nabu();
export const Service$isNabu = (value) => value instanceof Nabu;

export class Hermes extends $CustomType {}
export const Service$Hermes = () => new Hermes();
export const Service$isHermes = (value) => value instanceof Hermes;

export class Admin extends $CustomType {}
export const Service$Admin = () => new Admin();
export const Service$isAdmin = (value) => value instanceof Admin;

export class FetchError extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const AskError$FetchError = ($0) => new FetchError($0);
export const AskError$isFetchError = (value) => value instanceof FetchError;
export const AskError$FetchError$0 = (value) => value[0];

export class DecodeError extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const AskError$DecodeError = ($0) => new DecodeError($0);
export const AskError$isDecodeError = (value) => value instanceof DecodeError;
export const AskError$DecodeError$0 = (value) => value[0];

export class HttpError extends $CustomType {
  constructor(code, reason) {
    super();
    this.code = code;
    this.reason = reason;
  }
}
export const AskError$HttpError = (code, reason) => new HttpError(code, reason);
export const AskError$isHttpError = (value) => value instanceof HttpError;
export const AskError$HttpError$code = (value) => value.code;
export const AskError$HttpError$0 = (value) => value.code;
export const AskError$HttpError$reason = (value) => value.reason;
export const AskError$HttpError$1 = (value) => value.reason;

class Json extends $CustomType {
  constructor(content) {
    super();
    this.content = content;
  }
}

class Blob extends $CustomType {
  constructor(content) {
    super();
    this.content = content;
  }
}

class FormData extends $CustomType {
  constructor(content) {
    super();
    this.content = content;
  }
}

class Ask extends $CustomType {
  constructor(access_token, body, decoder, method, on_end, on_error, on_start, on_success, path, query_params, service, headers) {
    super();
    this.access_token = access_token;
    this.body = body;
    this.decoder = decoder;
    this.method = method;
    this.on_end = on_end;
    this.on_error = on_error;
    this.on_start = on_start;
    this.on_success = on_success;
    this.path = path;
    this.query_params = query_params;
    this.service = service;
    this.headers = headers;
  }
}

/**
 * Initialize a query, targeting a service, and provide a path.
 * By default, it will run a GET request, and will decode a `Dynamic` data.
 *
 * ```gleam
 * ask.to(ask.Heimdall, at: "/example")
 * |> ask.run
 * ```
 */
export function to(service, path) {
  return new Ask(
    new None(),
    new None(),
    $decode.dynamic,
    new $http.Get(),
    new None(),
    new None(),
    new None(),
    new None(),
    $path.from_segments(path),
    toList([]),
    service,
    toList([]),
  );
}

/**
 * Add a header to the http request
 * Be careful : reserved key will be overrided (FI: "authorization")
 *
 * ```gleam
 * ask.to(ask.Heimdall, at: "/path")
 * |> ask.add_header("bibi", "bubu")
 * |> ask.run
 * ```
 */
export function add_header(ask, key, value) {
  let headers = $list.prepend(ask.headers, [key, value]);
  return new Ask(
    ask.access_token,
    ask.body,
    ask.decoder,
    ask.method,
    ask.on_end,
    ask.on_error,
    ask.on_start,
    ask.on_success,
    ask.path,
    ask.query_params,
    ask.service,
    headers,
  );
}

/**
 * Accept an access token, and put it in `Authorization` header, prepended
 * correctly. `Authorization = Bearer [access_token]`
 *
 * ```gleam
 * ask.to(ask.Heimdall, at: "/example")
 * |> ask.bearing(access_token: "my-access-token")
 * |> ask.run
 * ```
 */
export function bearing(ask, access_token) {
  let access_token$1 = new Some(access_token);
  return new Ask(
    access_token$1,
    ask.body,
    ask.decoder,
    ask.method,
    ask.on_end,
    ask.on_error,
    ask.on_start,
    ask.on_success,
    ask.path,
    ask.query_params,
    ask.service,
    ask.headers,
  );
}

/**
 * Decode the resulting `Dynamic`. `Ask` will take the correct type, and will
 * make sure you're not messing up with types.
 *
 * ```gleam
 * ask.to(ask.Heimdall, at: "/path")
 * |> ask.expect(format: {
 *   use field1 <- decode.field("field1", decode.string)
 *   use field2 <- decode.field("field2", decode.int)
 *   decode.success(#(field1, field2))
 * })
 * |> ask.run
 * ```
 */
export function expect(ask, decoder) {
  return new Ask(
    ask.access_token,
    ask.body,
    decoder,
    ask.method,
    ask.on_end,
    ask.on_error,
    ask.on_start,
    new None(),
    ask.path,
    ask.query_params,
    ask.service,
    ask.headers,
  );
}

/**
 * Provide a body to the request. The body should be a `Json`.
 * Look at `blob` to provide a binary (i.e. `BitArray`), and at `form_data` to
 * provide a form-data (i.e. `FormData`).
 */
export function json(ask, content) {
  let body = new Json(content);
  let body$1 = new Some(body);
  return new Ask(
    ask.access_token,
    body$1,
    ask.decoder,
    ask.method,
    ask.on_end,
    ask.on_error,
    ask.on_start,
    ask.on_success,
    ask.path,
    ask.query_params,
    ask.service,
    ask.headers,
  );
}

/**
 * Provide a body to the request. The body should be a binary, as a `BitArray`.
 * Look at `json` to provide a JSON (i.e. `Json`), and at `form_data` to
 * provide a form-data (i.e. `FormData`).
 */
export function blob(ask, content) {
  let body = new Blob(content);
  let body$1 = new Some(body);
  return new Ask(
    ask.access_token,
    body$1,
    ask.decoder,
    ask.method,
    ask.on_end,
    ask.on_error,
    ask.on_start,
    ask.on_success,
    ask.path,
    ask.query_params,
    ask.service,
    ask.headers,
  );
}

/**
 * Provide a body to the request. The body should be a `FormData`.
 * Look at `json` to provide a JSON (i.e. `Json`) and at `blob` to
 * provide a binary (i.e. `BitArray`).
 */
export function form_data(ask, form_data) {
  let body = new FormData(form_data);
  let body$1 = new Some(body);
  return new Ask(
    ask.access_token,
    body$1,
    ask.decoder,
    ask.method,
    ask.on_end,
    ask.on_error,
    ask.on_start,
    ask.on_success,
    ask.path,
    ask.query_params,
    ask.service,
    ask.headers,
  );
}

/**
 * Provide a body to the request. The body should be a `Json`.
 * Look at `gift` to provide a binary (i.e. `BitArray`), and at `data` to
 * provide a form-data (i.e. `FormData`).
 */
export function with$(ask, content) {
  return new Ask(
    ask.access_token,
    new $option.Some(new Json(content)),
    ask.decoder,
    ask.method,
    ask.on_end,
    ask.on_error,
    ask.on_start,
    ask.on_success,
    ask.path,
    ask.query_params,
    ask.service,
    ask.headers,
  );
}

/**
 * Provide a query part of the URI. `query` is a pair of key-value as strings,
 * and are injected at the end of the URI, before the fragment.
 * As a reminder, a URI looks like `protocol://hostname:port/path?query#fragment`.
 * `query` can be chained to set multiple query params.
 *
 * ```gleam
 * ask.to(ask.Heimdall, at: "/first/second")
 * |> ask.query(for: "first", with: "value")
 * |> ask.query(for: "second", with: "value")
 * |> ask.query(for: "third", with: "value")
 * |> ask.run
 * ```
 */
export function query(ask, key, value) {
  let query_params = $assoc.set(ask.query_params, key, value);
  return new Ask(
    ask.access_token,
    ask.body,
    ask.decoder,
    ask.method,
    ask.on_end,
    ask.on_error,
    ask.on_start,
    ask.on_success,
    ask.path,
    query_params,
    ask.service,
    ask.headers,
  );
}

/**
 * Set the HTTP method to use.
 *
 * ```gleam
 * ask.to(ask.Heimdall, at: "/example")
 * |> ask.via(method: http.Post)
 * |> ask.run
 * ```
 */
export function via(ask, method) {
  return new Ask(
    ask.access_token,
    ask.body,
    ask.decoder,
    method,
    ask.on_end,
    ask.on_error,
    ask.on_start,
    ask.on_success,
    ask.path,
    ask.query_params,
    ask.service,
    ask.headers,
  );
}

/**
 * Set a notifier to run after the data has been received and decoded.
 * The notifier _will not_ run if the decoding fails.
 * It should send a message corresponding to the decoded message.
 */
export function on_success(ask, on_success) {
  return new Ask(
    ask.access_token,
    ask.body,
    ask.decoder,
    ask.method,
    ask.on_end,
    ask.on_error,
    ask.on_start,
    new Some(
      (data) => {
        on_success(data);
        return undefined;
      },
    ),
    ask.path,
    ask.query_params,
    ask.service,
    ask.headers,
  );
}

/**
 * Set a notifier to run after the data has been received, and failed to decode.
 * The notifier _will not_ run if the decoding success.
 * It should send a message corresponding to the error.
 */
export function on_error(ask, on_error) {
  return new Ask(
    ask.access_token,
    ask.body,
    ask.decoder,
    ask.method,
    ask.on_end,
    new Some(
      (data) => {
        on_error(data);
        return undefined;
      },
    ),
    ask.on_start,
    ask.on_success,
    ask.path,
    ask.query_params,
    ask.service,
    ask.headers,
  );
}

/**
 * Define a callback that will run before the the notifier.
 */
export function on_start(ask, on_start) {
  return new Ask(
    ask.access_token,
    ask.body,
    ask.decoder,
    ask.method,
    ask.on_end,
    ask.on_error,
    new Some(
      () => {
        on_start();
        return undefined;
      },
    ),
    ask.on_success,
    ask.path,
    ask.query_params,
    ask.service,
    ask.headers,
  );
}

/**
 * Define a callback that will run after the notifier.
 */
export function on_end(ask, on_end) {
  return new Ask(
    ask.access_token,
    ask.body,
    ask.decoder,
    ask.method,
    new Some(
      () => {
        on_end();
        return undefined;
      },
    ),
    ask.on_error,
    ask.on_start,
    ask.on_success,
    ask.path,
    ask.query_params,
    ask.service,
    ask.headers,
  );
}

function on_run(ask, exception, response) {
  let on_success$1 = $option.unwrap(
    ask.on_success,
    (_) => { return undefined; },
  );
  let on_error$1 = $option.unwrap(ask.on_error, (_) => { return undefined; });
  if (response instanceof Ok) {
    let data = response[0];
    return on_success$1(data);
  } else {
    let error = response[0];
    let $ = $posthog.capture_exception(exception, error);
    
    return on_error$1(error);
  }
}

function status_to_string(status) {
  if (status === 403) {
    return "Forbidden";
  } else if (status === 422) {
    return "Unprocessable Content";
  } else if (status === 429) {
    return "Too Many Requests";
  } else if (status === 503) {
    return "Service Unavailable";
  } else if (status === 504) {
    return "Gateway timeout";
  } else {
    return "Internal server error";
  }
}

function http_error(response) {
  let code = response.status;
  let reason = status_to_string(response.status);
  let _pipe = new HttpError(code, reason);
  return new Error(_pipe);
}

function map_result(response, decoder) {
  if (response instanceof Ok) {
    let response$1 = response[0];
    if (response$1.status >= 300) {
      return $p.resolve(http_error(response$1));
    } else {
      let response$1 = response[0];
      let _pipe = $fetch.read_json_body(response$1);
      let _pipe$1 = $p.map(
        _pipe,
        (_capture) => {
          return $result.map_error(
            _capture,
            (var0) => { return new FetchError(var0); },
          );
        },
      );
      return $p.map_try(
        _pipe$1,
        (response) => {
          let _pipe$2 = response.body;
          let _pipe$3 = $decode.run(_pipe$2, decoder);
          return $result.map_error(
            _pipe$3,
            (var0) => { return new DecodeError(var0); },
          );
        },
      );
    }
  } else {
    let error = response[0];
    return $p.resolve(new Error(new FetchError(error)));
  }
}

function apply_body_and_send(request, ask) {
  let $ = ask.body;
  if ($ instanceof Some) {
    let $1 = $[0];
    if ($1 instanceof Json) {
      let content = $1.content;
      let _pipe = content;
      let _pipe$1 = $json.to_string(_pipe);
      let _pipe$2 = ((_capture) => {
        return $request.set_body(request, _capture);
      })(_pipe$1);
      return $fetch.send(_pipe$2);
    } else if ($1 instanceof Blob) {
      let content = $1.content;
      let _pipe = content;
      let _pipe$1 = ((_capture) => {
        return $request.set_body(request, _capture);
      })(_pipe);
      return $fetch.send_bits(_pipe$1);
    } else {
      let content = $1.content;
      let _pipe = content;
      let _pipe$1 = ((_capture) => {
        return $request.set_body(request, _capture);
      })(_pipe);
      return $fetch.send_form_data(_pipe$1);
    }
  } else {
    return $fetch.send(request);
  }
}

/**
 * Apply the correct `content-type` to the request. When sending JSON,
 * set `content-type` to `application/json`, when sending a blob, send
 * `application/octet-stream`, when sending a `FormData`, directly send
 * it to let `fetch` infer the `content-type`.
 * 
 * @ignore
 */
function apply_content_type(request, ask) {
  let content_type = (_capture) => {
    return $request.set_header(request, "content-type", _capture);
  };
  let $ = ask.body;
  if ($ instanceof Some) {
    let $1 = $[0];
    if ($1 instanceof Json) {
      return content_type("application/json");
    } else if ($1 instanceof Blob) {
      return content_type("application/octet-stream");
    } else {
      return request;
    }
  } else {
    return request;
  }
}

function apply_access_token(request, ask) {
  let _pipe = ask.access_token;
  let _pipe$1 = $option.map(
    _pipe,
    (_capture) => { return $string.append("Bearer ", _capture); },
  );
  let _pipe$2 = $option.map(
    _pipe$1,
    (_capture) => {
      return $request.set_header(request, "authorization", _capture);
    },
  );
  return $option.unwrap(_pipe$2, request);
}

function apply_headers(request, ask) {
  return $list.fold(
    ask.headers,
    request,
    (acc, val) => { return $request.set_header(acc, val[0], val[1]); },
  );
}

function prepend_slash(path) {
  let $ = $string.starts_with(path, "/");
  if ($) {
    return path;
  } else {
    return $string.append("/", path);
  }
}

function service_uri(service) {
  let _block;
  if (service instanceof Loki) {
    _block = $endpoints.loki();
  } else if (service instanceof Heimdall) {
    _block = $endpoints.heimdall();
  } else if (service instanceof Nabu) {
    _block = $endpoints.nabu();
  } else if (service instanceof Hermes) {
    _block = $endpoints.hermes();
  } else {
    _block = $endpoints.heimdall() + "/admin";
  }
  let uri = _block;
  let $ = $uri.parse(uri);
  let uri$1;
  if ($ instanceof Ok) {
    uri$1 = $[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "altar/ask",
      328,
      "service_uri",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 10059,
        end: 10094,
        pattern_start: 10070,
        pattern_end: 10077
      }
    )
  }
  return uri$1;
}

/**
 * Execute the query. `run` will return the resulting `Promise`, and will
 * trigger the different notifiers, decoders, etc.
 */
export function run(ask) {
  let exception = $posthog.exception();
  let endpoint = service_uri(ask.service);
  let path = endpoint.path + prepend_slash(ask.path);
  let endpoint$1 = new $uri.Uri(
    endpoint.scheme,
    endpoint.userinfo,
    endpoint.host,
    endpoint.port,
    path,
    endpoint.query,
    endpoint.fragment,
  );
  let $ = $request.from_uri(endpoint$1);
  let request;
  if ($ instanceof Ok) {
    request = $[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "altar/ask",
      244,
      "run",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 7173,
        end: 7224,
        pattern_start: 7184,
        pattern_end: 7195
      }
    )
  }
  let _pipe = request;
  let _pipe$1 = $request.set_method(_pipe, ask.method);
  let _pipe$2 = $request.set_header(_pipe$1, "accept", "application/json");
  let _pipe$3 = $request.set_query(_pipe$2, ask.query_params);
  let _pipe$4 = apply_headers(_pipe$3, ask);
  let _pipe$5 = apply_access_token(_pipe$4, ask);
  let _pipe$6 = apply_content_type(_pipe$5, ask);
  let _pipe$7 = apply_body_and_send(_pipe$6, ask);
  let _pipe$8 = $p.await$(
    _pipe$7,
    (_capture) => { return map_result(_capture, ask.decoder); },
  );
  return $p.tap(
    _pipe$8,
    (response) => {
      let on_end$1 = $option.unwrap(ask.on_end, () => { return undefined; });
      let on_start$1 = $option.unwrap(ask.on_start, () => { return undefined; });
      on_start$1();
      on_run(ask, exception, response);
      return on_end$1();
    },
  );
}

/**
 * Pleasant alternative to `promise.try_await`. Use it to chain ask
 * computations.
 *
 * ```gleam
 * use value1 <- ask.then(ask.to(ask.Heimdall, at: ["example1"]) |> ask.run)
 * use value2 <- ask.then(ask.to(ask.Heimdall, at: ["example2"]) |> ask.run)
 * use value3 <- ask.then(ask.to(ask.Heimdall, at: ["example2"]) |> ask.run)
 * ask.success(#(value1, value2, value3))
 * ```
 */
export function then$(asked, next) {
  return $p.try_await(asked, next);
}

/**
 * Take a value, and consider it as a valid result from `ask.run`.
 * Use it to end your chain of computations.
 *
 * ```gleam
 * use value1 <- ask.then(ask.to(ask.Heimdall, at: ["example1"]) |> ask.run)
 * use value2 <- ask.then(ask.to(ask.Heimdall, at: ["example2"]) |> ask.run)
 * use value3 <- ask.then(ask.to(ask.Heimdall, at: ["example2"]) |> ask.run)
 * ask.success(#(value1, value2, value3))
 * ```
 */
export function success(value) {
  let _pipe = new Ok(value);
  return $p.resolve(_pipe);
}

/**
 * Take 2 values, and await for both before returning. Contrarily to awaiting
 * for every promises one by one, they're all running in the same time.
 *
 * ```gleam
 * let value1 = ask.to(ask.Heimdall, at: ["example1"]) |> ask.run
 * let value2 = ask.to(ask.Heimdall, at: ["example2"]) |> ask.run
 * use #(a, b) <- ask.then(ask.batch2(value1, value2))
 * ```
 */
export function batch2(a, b) {
  return then$(
    a,
    (a) => { return then$(b, (b) => { return success([a, b]); }); },
  );
}

/**
 * Take 3 values, and await for both before returning. Contrarily to awaiting
 * for every promises one by one, they're all running in the same time.
 *
 * ```gleam
 * let value1 = ask.to(ask.Heimdall, at: ["example1"]) |> ask.run
 * let value2 = ask.to(ask.Heimdall, at: ["example2"]) |> ask.run
 * let value3 = ask.to(ask.Heimdall, at: ["example3"]) |> ask.run
 * use #(a, b, c) <- ask.then(ask.batch3(value1, value2, value3))
 * ```
 */
export function batch3(a, b, c) {
  return then$(
    a,
    (a) => {
      return then$(
        b,
        (b) => { return then$(c, (c) => { return success([a, b, c]); }); },
      );
    },
  );
}
